import type {Alias} from '../../types'
import {SERVICE} from './by-alias/service'
import {VIRT} from './by-alias/virt'
import type {TvmByAlias} from './types'

export const tvmByAliasByEnv = {
  service: SERVICE,
  virt: VIRT,
} satisfies {[key in Alias]: TvmByAlias}
